export const ENV = import.meta.env.VITE_ENV || 'development';
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const API_AUTH_URL = import.meta.env.VITE_API_AUTH_URL;
export const API_MASTERDATA_URL = import.meta.env.VITE_API_MASTERDATA_URL;
export const AUTH_TOKEN = import.meta.env.VITE_AUTH_TOKEN;

export const LOGISTIC_KEYCLOACK_URL = import.meta.env.VITE_LOGISTIC_KEYCLOACK_URL;
export const LOGISTIC_KEYCLOACK_REALM = import.meta.env.VITE_LOGISTIC_KEYCLOACK_REALM;
export const LOGISTIC_KEYCLOACK_CLIENT_ID = import.meta.env.VITE_LOGISTIC_KEYCLOACK_CLIENT_ID;
export const LOGISTIC_KEYCLOACK_CLIENT_SECRET = import.meta.env
  .VITE_LOGISTIC_KEYCLOACK_CLIENT_SECRET;
